import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { SharedDataService } from '@teem/services/shared-data.service';
import { invoice as InvoiceApi } from '@teem/constants/api';
import { Select2Directive } from "@teem/directives/select2.directive";
import { AddItemsComponent } from '@teem/quotes-module/modals/add-items/add-items.component';
import { messages as i18n } from '@teem/constants/messages';


@Component({
  selector: 'quote-deliverable-form',
  templateUrl: './deliverable.component.html',
  styles: []
})
export class DeliverableComponent implements OnInit {
  @Input() formId: string;
  @Input() form: FormGroup;
  @Input() index: number;
  @Input() formType: string;
  @Input() deliverableList: any;
  @Output() onSubmit: EventEmitter<FormGroup> = new EventEmitter();
  @Output() onCancel: EventEmitter<any> = new EventEmitter();
  @ViewChild(Select2Directive) select2Directive = null
  @ViewChild('newItemTitle') newItemTitle: any;
  isSubmitted = false;
  deliverable: object;
  oldValues: any;
  itemTitleText: string = i18n.invoice.add_new_item;
  productsServicesListApi: string = InvoiceApi.products_services_list;
  isProPlan: any;

  constructor(
    private fb: FormBuilder,
    private modalService: NgbModal,
    private sharedDataService: SharedDataService) {
  }

  ngOnInit() {
    this.oldValues = Object.assign({}, this.form.value);

    if (this.form.value && this.form.value.title) {
      this.selectedItem = {
        id: this.form.value.title,
        name: this.form.value.title
      }
    }
  }

  selectedItem: any;
  onChangeItem(value: any) {
    if (value) {
      if (value.id == '__add_new_items__') {
        this.select2Directive.clear();
        const modalRef = this.modalService.open(AddItemsComponent);

        // Set id on modal dialog
        modalRef.componentInstance.el.nativeElement.parentNode.parentNode.parentNode.id = "addNewItems";
        modalRef.componentInstance.formType = this.formType;
        modalRef.componentInstance.form = this.form;
        modalRef.componentInstance.formId = this.formId;
        modalRef.componentInstance.onSubmit = this.onSubmit;
        this.form.get('quantity').setValue(1);
        modalRef.result.then(result => {
          console.log(result);
        }, fallbackResult => {
          this.selectedItem = null;
          this.onCancel.emit(this.form);
        });


      } else {
        this.selectedItem = {
          id: value.text,
          name: value.text
        }

        this.form.get('rate').setValue(value.price);

        if (!this.form.get('quantity').value)
          this.form.get('quantity').setValue(1);
        this.submit();
      }
    } else {
      this.form.get('title').setValue(null);
    }
  }

  submit() {
    this.isSubmitted = true;
    if (this.form.valid) {
      this.onSubmit.emit(this.form);

      if (this.formType == "addNew") {
        this.form.reset({});

        if (this.newItemTitle && this.newItemTitle.clear)
          this.newItemTitle.clear();

        this.form.get('title').setValue(null);
        this.selectedItem = null;
      }

      this.isSubmitted = false;
    } else {
      console.log('error')
    }
  }

  cancel() {
    this.form.reset(this.oldValues);
    this.onCancel.emit(this.form);
  }
}
